import React, { useEffect, useRef, useState } from "react";

const IdleScreensaver = ({ timeoutMs = 5 * 60 * 1000, enabled = true }) => {
  const [idle, setIdle] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    const startTimer = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setIdle(true), timeoutMs);
    };
    const wake = () => {
      if (idle) setIdle(false);
      startTimer();
    };

    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];
    events.forEach((ev) => window.addEventListener(ev, wake, { passive: true }));
    startTimer();

    return () => {
      clearTimeout(timerRef.current);
      events.forEach((ev) => window.removeEventListener(ev, wake));
    };
  }, [enabled, timeoutMs, idle]);

  if (!idle) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        background: "linear-gradient(180deg, #1b2a4a 0%, #24365c 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "none",
        userSelect: "none",
      }}
    >
      <style>{`
        @keyframes breathe {
          0%,100% { transform: scale(1); }
          50% { transform: scale(1.04); }
        }
        @keyframes zzz {
          0%   { opacity: 0; transform: translate(0,0) scale(0.8); }
          30%  { opacity: 1; }
          100% { opacity: 0; transform: translate(30px,-60px) scale(1.3); }
        }
        @keyframes wake {
          0%,100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
        .zzz-letter { animation: zzz 3s ease-in-out infinite; }
        .zzz-letter.z2 { animation-delay: 1s; }
        .zzz-letter.z3 { animation-delay: 2s; }
      `}</style>

      {/* Sleeping cartoon */}
      <div style={{ position: "relative", animation: "breathe 4s ease-in-out infinite" }}>
        <svg width="220" height="180" viewBox="0 0 220 180">
          {/* body / blob character */}
          <ellipse cx="110" cy="120" rx="80" ry="45" fill="#ffd36e" />
          <ellipse cx="110" cy="118" rx="80" ry="42" fill="#ffdd88" />

          {/* closed sleeping eyes */}
          <path d="M80 108 q10 8 20 0" stroke="#5a4a2a" strokeWidth="3" fill="none" strokeLinecap="round" />
          <path d="M120 108 q10 8 20 0" stroke="#5a4a2a" strokeWidth="3" fill="none" strokeLinecap="round" />

          {/* rosy cheeks */}
          <circle cx="78" cy="122" r="7" fill="#ff9a9a" opacity="0.6" />
          <circle cx="142" cy="122" r="7" fill="#ff9a9a" opacity="0.6" />

          {/* little sleeping mouth */}
          <ellipse cx="110" cy="132" rx="7" ry="5" fill="#5a4a2a" opacity="0.7" />

          {/* tiny blanket line */}
          <path d="M35 138 q75 25 150 0" stroke="#e0b84f" strokeWidth="4" fill="none" opacity="0.5" />
        </svg>

        {/* floating Zzz */}
        <div style={{ position: "absolute", top: -10, right: 6 }}>
          <span className="zzz-letter" style={{ position: "absolute", color: "#fff", fontSize: 20, fontWeight: 700 }}>z</span>
          <span className="zzz-letter z2" style={{ position: "absolute", color: "#fff", fontSize: 26, fontWeight: 700 }}>Z</span>
          <span className="zzz-letter z3" style={{ position: "absolute", color: "#fff", fontSize: 32, fontWeight: 700 }}>Z</span>
        </div>
      </div>

      <div style={{ marginTop: 40, color: "#cdd7ee", fontSize: "1rem", letterSpacing: 1, animation: "wake 2.5s ease-in-out infinite" }}>
        Taking a little rest… move the mouse to wake up
      </div>
    </div>
  );
};

export default IdleScreensaver;